@if (objectForm) {
    <nz-spin [nzSpinning]="loading">
        <form nz-form [formGroup]="objectForm" class="login-form" nzLayout="vertical">
            <div nz-row nzGutter="8">
                <div nz-col [nzXXl]="12" [nzXl]="12" [nzLg]="12">
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="documentTypeId">Dokumenta veids</nz-form-label>
                        <nz-form-control clValidationError="documentTypeId">
                            <nz-select nzShowSearch nzPlaceHolder="Dokumenta veids" formControlName="documentTypeId">
                                @for (documentType of documentTypes$ | async; track documentType.id) {
                                    <nz-option [nzLabel]="documentType.name" [nzValue]="documentType.id"></nz-option>
                                }
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="number">Dokumenta numurs</nz-form-label>
                        <nz-form-control clValidationError="number">
                            <input type="text" nz-input formControlName="number" id="number" />
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzFor="date">Datums</nz-form-label>
                        <nz-form-control clValidationError="date">
                            <nz-date-picker
                                class="w-100"
                                id="date"
                                formControlName="date"
                                [nzFormat]="'dd.MM.yyyy'"
                                [nzPlaceHolder]="'Datums'"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzFor="validUntil">Derīgs līdz</nz-form-label>
                        <nz-form-control clValidationError="validUntil">
                            <nz-date-picker
                                class="w-100"
                                id="validUntil"
                                formControlName="validUntil"
                                [nzFormat]="'dd.MM.yyyy'"
                                [nzPlaceHolder]="'Derīgs līdz'"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzXXl]="12" [nzXl]="24" [nzLg]="12">
                    <nz-form-item>
                        <nz-form-label nzFor="notes">Piezīmes</nz-form-label>
                        <nz-form-control clValidationError="notes">
                            <textarea rows="8" nz-input class="w-100" id="notes" formControlName="notes" placeholder="Piezīmes"></textarea>
                        </nz-form-control>
                    </nz-form-item>
                    @if (canEditFields) {
                        <div nz-row class="align-items-center" [nzJustify]="'space-around'">
                            @if (visibleCheckboxes.includes('isGenerated')) {
                                <nz-form-item>
                                    <nz-form-label nzFor="isGenerated" [nzNoColon]="true"></nz-form-label>
                                    <nz-form-control>
                                        <label
                                            nz-checkbox
                                            id="isGenerated"
                                            formControlName="isGenerated"
                                            (ngModelChange)="validateAndSaveIfEditMode()"
                                            >Ģenerēts</label
                                        >
                                    </nz-form-control>
                                </nz-form-item>
                            }
                            @if (visibleCheckboxes.includes('isPrintableInContract')) {
                                <nz-form-item>
                                    <nz-form-label nzFor="isPrintableInContract" [nzNoColon]="true"></nz-form-label>
                                    <nz-form-control>
                                        <label
                                            nz-checkbox
                                            id="isPrintableInContract"
                                            formControlName="isPrintableInContract"
                                            (ngModelChange)="validateAndSaveIfEditMode()"
                                            >Iekļaut līgumā</label
                                        >
                                    </nz-form-control>
                                </nz-form-item>
                            }
                            @if (visibleCheckboxes.includes('isPublishableInPortal')) {
                                <nz-form-item>
                                    <nz-form-label nzFor="isPublishableInPortal" [nzNoColon]="true"></nz-form-label>
                                    <nz-form-control>
                                        <label
                                            nz-checkbox
                                            id="isPublishableInPortal"
                                            formControlName="isPublishableInPortal"
                                            (ngModelChange)="validateAndSaveIfEditMode()"
                                            >Publicēt portalā</label
                                        >
                                    </nz-form-control>
                                </nz-form-item>
                            }
                            @if (visibleCheckboxes.includes('isPublishableInProfile')) {
                                <nz-form-item>
                                    <nz-form-label nzFor="isPublishableInProfile" [nzNoColon]="true"></nz-form-label>
                                    <nz-form-control>
                                        <label
                                            nz-checkbox
                                            id="isPublishableInProfile"
                                            formControlName="isPublishableInProfile"
                                            (ngModelChange)="validateAndSaveIfEditMode()"
                                            >Rādīt izpildītāja profilā</label
                                        >
                                    </nz-form-control>
                                </nz-form-item>
                            }
                            @if (visibleCheckboxes.includes('isSignable')) {
                                <nz-form-item>
                                    <nz-form-label nzFor="isSignable" [nzNoColon]="true"></nz-form-label>
                                    <nz-form-control>
                                        <label nz-checkbox id="isSignable" formControlName="isSignable" (ngModelChange)="validateAndSaveIfEditMode()"
                                            >Ir parakstāms</label
                                        >
                                    </nz-form-control>
                                </nz-form-item>
                            }
                        </div>
                    }
                </div>
            </div>
            <div nz-row nzGutter="8">
                <ng-container *hasPermission="[GroupPermissions.CONTRACT_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('contractId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="contractId">Līgums</nz-form-label>
                                <nz-form-control clValidationError="contractId">
                                    <cl-search-field-form-control
                                        formControlName="contractId"
                                        fieldPlaceholder="Līgums"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.Contract"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.SCONTRACT_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('scontractId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="scontractId">Sadarbības līgums</nz-form-label>
                                <nz-form-control clValidationError="scontractId">
                                    <cl-search-field-form-control
                                        formControlName="scontractId"
                                        fieldPlaceholder="Sadarbības līgums"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.Scontract"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.WORK_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('workId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="workId">Darbs</nz-form-label>
                                <nz-form-control clValidationError="workId">
                                    <cl-search-field-form-control
                                        formControlName="workId"
                                        fieldPlaceholder="Darbs"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.Work"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.CRM_EVENT_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('crmEventId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="crmEventId">CRM notikums</nz-form-label>
                                <nz-form-control clValidationError="crmEventId">
                                    <cl-search-field-form-control
                                        formControlName="crmEventId"
                                        fieldPlaceholder="CRM notikums"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.CrmEvent"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.FUEL_REPORT_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('fuelReportId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="fuelReportId">Degvielas atskaite</nz-form-label>
                                <nz-form-control clValidationError="fuelReportId">
                                    <cl-search-field-form-control
                                        formControlName="fuelReportId"
                                        fieldPlaceholder="Degvielas atskaite"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.FuelReport"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.PAYOUT_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('payoutId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="payoutId">Izmaksa</nz-form-label>
                                <nz-form-control clValidationError="payoutId">
                                    <cl-search-field-form-control
                                        formControlName="payoutId"
                                        fieldPlaceholder="Izmaksa"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.Payout"
                                        [customSearchFn]="searchBetweenRevenuePayouts"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
                <ng-container *hasPermission="[GroupPermissions.PERFORMER_EDIT]">
                    @if (visibleDocumentOwnershipInputs.includes('performerId')) {
                        <nz-col [nzXXl]="6" [nzXl]="6" [nzLg]="9" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                            <nz-form-item>
                                <nz-form-label nzFor="performerId">Izpildītājs</nz-form-label>
                                <nz-form-control clValidationError="performerId">
                                    <cl-search-field-form-control
                                        formControlName="performerId"
                                        fieldPlaceholder="Izpildītājs"
                                        [allowClear]="true"
                                        [modelType]="SearchFieldModelType.Performer"
                                        [customSearchFn]="searchBetweenPerformersRelatedToUser"
                                        [customToStringFn]="performerToStringFn"
                                        [minimumSearchTextLengthThreshold]="1"
                                    >
                                    </cl-search-field-form-control>
                                </nz-form-control>
                            </nz-form-item>
                        </nz-col>
                    }
                </ng-container>
            </div>
            @if (isEditMode) {
                <nz-collapse [nzBordered]="false">
                    <nz-collapse-panel [nzHeader]="'Dokumenta faili'" [nzActive]="true">
                        <nz-upload
                            [nzAccept]="
                                'image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/xml, text/xml, .xml, .asice, .edoc'
                            "
                            class="mb-3"
                            [nzSize]="100000"
                            [nzBeforeUpload]="beforeDocumentFileUpload"
                            [nzShowUploadList]="false"
                            [nzCustomRequest]="customUploadRequest"
                            [nzMultiple]="true"
                        >
                            <button nz-button><i nz-icon nzType="upload"></i>Pievienot</button>
                        </nz-upload>
                        <cl-document-files-table
                            [(document)]="originalObject"
                            (documentChange)="documentChanged($event)"
                            [documentIsSignable]="documentIsSignable"
                            [canEditFields]="canEditFields"
                            [isEditMode]="isEditMode"
                        ></cl-document-files-table>
                    </nz-collapse-panel>
                </nz-collapse>
            }
            <div *nzModalFooter class="modal-footer">
                <div class="modal-footer-left">
                    @if (isEditMode) {
                        <cl-info-button
                            [id]="originalObject.id"
                            [entityType]="EntityType.Document"
                            (loadingChanged)="loading = $event"
                        ></cl-info-button>

                        <cl-notification-history-button
                            [entityType]="EntityType.Document"
                            [id]="originalObject.id"
                            class="ml-2"
                        ></cl-notification-history-button>
                    }
                </div>
                <div class="modal-footer-right">
                    @if (canEditFields) {
                        <button nz-button nzType="default" [disabled]="loading" (click)="cancel()">Atcelt</button>
                        <button nz-button nzType="primary" [disabled]="loading" (click)="validateAndSave()">Saglabāt</button>
                    }
                </div>
            </div>
        </form>
    </nz-spin>
}
